import HierarchyItemEventView from './HierarchyItemEventView';

export default HierarchyItemEventView;
